import type React from 'react'
import type { JSX } from 'react'

import { EpgHeadSC } from './EpgHeadPlayer.styled'

export interface IEpgHeadPlayerProps {
  children: React.ReactNode
}

export const EpgHeadPlayer = ({
  children,
}: IEpgHeadPlayerProps): JSX.Element => {
  return <EpgHeadSC>{children}</EpgHeadSC>
}
